<auth-splash-page>
  @if (colorMode.currentMode() === 'dark') {
    <img
      src="/assets/img/compass-logo-dark.png"
      class="align-self-center"
      alt="Compass logo"
      width="245"
      height="245"
    />
    <img src="/assets/img/brand-text-dark.png" class="mb-3" alt="CRST Compass" width="304" height="54" />
  } @else {
    <img src="/assets/img/compass-logo.png" class="align-self-center" alt="Compass logo" width="245" height="245" />
    <img src="/assets/img/brand-text.png" class="mb-3" alt="CRST Compass" width="304" height="54" />
  }
  <h1 class="mb-2 text-center">Registration</h1>
  <p class="mx-auto text-center">
    Create your account and ensure strong passwords by incorporating elements like numbers, a mix of uppercase and
    lowercase letters, as well as symbols.
  </p>
  <form #registerForm="ngForm" class="d-flex flex-column mb-3" (submit)="submitRegistration()">
    <mat-form-field>
      <mat-label>Email</mat-label>
      <input matInput name="email" disabled [ngModel]="temporarySession().maskedEmail" />
    </mat-form-field>
    <mat-form-field [hideRequiredMarker]="true">
      <mat-label>Full Name</mat-label>
      <input
        matInput
        placeholder="First & Last Name"
        name="name"
        autocomplete="name"
        [(ngModel)]="formData.name"
        required
      />
    </mat-form-field>
    <auth-new-password [formData]="formData" />
    <button matButton="filled" [disabled]="registerForm.invalid">Confirm</button>
  </form>
</auth-splash-page>
